import React from 'react'
import img1 from "../../../Assets/blogDetails/blogImage.png"
import img2 from "../../../Assets/blogs/blogBedroom.png"
import pg1 from "../../../Assets/blogs/pgNo1.png"
import pg2 from "../../../Assets/blogs/pgNo2.png";
import pg3 from "../../../Assets/blogs/pgNo3.png";
import { MdKeyboardArrowRight } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
function Blogs() {
  const navigate=useNavigate();
return (
  <>
    <div className="flex flex-col  items-center sm:px-16 p-6">
      {/* first blog */}
      <div className="grid md:grid-cols-2 gap-5 grid-cols-1 py-5">
        <div className="flex flex-col gap-3 items-start" onClick={()=>navigate("/blog-details")}>
          <div className="xl:h-[90%]">
            {" "}
            <img
              src={img1}
              alt="img1"
              className="rounded-md object-cover h-full"
            />
          </div>
          <div className="flex flex-col gap-1 items-start tracking-wide">
            <h1 className="text-[#6B737A] text-sm">20-12-2024</h1>
            <p className="text-md font-bold">
              Internships, freelancing and more: ways to earn some extra bucks
              as a student
            </p>

            <button className="uppercase text-md font-bold text-[#00B1CE] flex items-center">
              Read More
              <MdKeyboardArrowRight className="text-[#00B1CE]" fontSize={20} />
            </button>
          </div>
        </div>
        <div className="flex flex-col gap-3 items-start" onClick={()=>navigate("/blog-details")}>
          <div className="xl:h-[90%]">
            {" "}
            <img
              src={img2}
              alt="img1"
              className="rounded-md object-cover h-full"
            />
          </div>
          <div className="flex flex-col gap-1 items-start tracking-wide">
            <h1 className="text-[#6B737A] text-sm">20-12-2024</h1>
            <p className="text-md font-bold">
              10 Ways to make your PG/Hostel room feel more like home
            </p>
            <button className="uppercase text-md font-bold text-[#00B1CE] flex items-center">
              Read More
              <MdKeyboardArrowRight className="text-[#00B1CE]" fontSize={20} />
            </button>
          </div>
        </div>
      </div>
      {/* second blog */}
      <div className="grid md:grid-cols-3 grid-cols-1 gap-5 py-5">
        <div className="flex flex-col gap-3 items-start" onClick={()=>{navigate("/blog-details")}}>
          <div className="xl:h-[90%]">
            {" "}
            <img
              src={pg1}
              alt="img1"
              className="rounded-md object-cover h-full"
            />
          </div>
          <div className="flex flex-col gap-1 items-start tracking-wide">
            <h1 className="text-[#6B737A] text-sm">20-12-2024</h1>
            <p className="text-md font-bold">
              10 Ways to make your PG/Hostel room feel more like home
            </p>

            <button className="uppercase text-md font-bold text-[#00B1CE] flex items-center">
              Read More
              <MdKeyboardArrowRight className="text-[#00B1CE]" fontSize={20} />
            </button>
          </div>
        </div>
        <div className="flex flex-col gap-3 items-start" onClick={()=>{navigate("/blog-details")}}>
          <div className="xl:h-[90%]">
            {" "}
            <img
              src={pg2}
              alt="img1"
              className="rounded-md object-cover h-full"
            />
          </div>
          <div className="flex flex-col gap-1 items-start tracking-wide">
            <h1 className="text-[#6B737A] text-sm">20-12-2024</h1>
            <p className="text-md font-bold">
              10 Ways to make your PG/Hostel room feel more like home
            </p>
            <button className="uppercase text-md font-bold text-[#00B1CE] flex items-center">
              Read More
              <MdKeyboardArrowRight className="text-[#00B1CE]" fontSize={20} />
            </button>
          </div>
        </div>
        <div className="flex flex-col gap-3 items-start" onClick={()=>{navigate("/blog-details")}}>
          <div className="xl:h-[90%]">
            {" "}
            <img
              src={pg3}
              alt="img1"
              className="rounded-md object-cover h-full"
            />
          </div>
          <div className="flex flex-col gap-1 items-start tracking-wide">
            <h1 className="text-[#6B737A] text-sm">20-12-2024</h1>
            <p className="text-md font-bold">
              10 Ways to make your PG/Hostel room feel more like home
            </p>
            <button className="uppercase text-md font-bold text-[#00B1CE] flex items-center">
              Read More
              <MdKeyboardArrowRight className="text-[#00B1CE]" fontSize={20} />
            </button>
          </div>
        </div>
      </div>
      {/* third blog */}
      <div className="grid md:grid-cols-2 gap-5 grid-cols-1 py-5">
        <div className="flex flex-col gap-3 items-start" onClick={()=>{navigate("/blog-details")}}>
          <div className="xl:h-[90%]">
            {" "}
            <img
              src={img1}
              alt="img1"
              className="rounded-md object-cover h-full"
            />
          </div>
          <div className="flex flex-col gap-1 items-start tracking-wide">
            <h1 className="text-[#6B737A] text-sm">20-12-2024</h1>
            <p className="text-md font-bold">
              Internships, freelancing and more: ways to earn some extra bucks
              as a student
            </p>

            <button className="uppercase text-md font-bold text-[#00B1CE] flex items-center">
              Read More
              <MdKeyboardArrowRight className="text-[#00B1CE]" fontSize={20} />
            </button>
          </div>
        </div>
        <div className="flex flex-col gap-3 items-start" onClick={()=>{navigate("/blog-details")}}>
          <div className="xl:h-[90%]">
            {" "}
            <img
              src={img2}
              alt="img1"
              className="rounded-md object-cover h-full"
            />
          </div>
          <div className="flex flex-col gap-1 items-start tracking-wide">
            <h1 className="text-[#6B737A] text-sm">20-12-2024</h1>
            <p className="text-md font-bold">
              10 Ways to make your PG/Hostel room feel more like home
            </p>
            <button className="uppercase text-md font-bold text-[#00B1CE] flex items-center">
              Read More
              <MdKeyboardArrowRight className="text-[#00B1CE]" fontSize={20} />
            </button>
          </div>
        </div>
      </div>
      {/* forth blog */}
      <div className="grid md:grid-cols-3 grid-cols-1 gap-5 py-5">
        <div className="flex flex-col gap-3 items-start" onClick={()=>{navigate("/blog-details")}}>
          <div className="xl:h-[90%]">
            {" "}
            <img
              src={pg1}
              alt="img1"
              className="rounded-md object-cover h-full"
            />
          </div>
          <div className="flex flex-col gap-1 items-start tracking-wide">
            <h1 className="text-[#6B737A] text-sm">20-12-2024</h1>
            <p className="text-md font-bold">
              10 Ways to make your PG/Hostel room feel more like home
            </p>

            <button className="uppercase text-md font-bold text-[#00B1CE] flex items-center">
              Read More
              <MdKeyboardArrowRight className="text-[#00B1CE]" fontSize={20} />
            </button>
          </div>
        </div>
        <div className="flex flex-col gap-3 items-start" onClick={()=>{navigate("/blog-details")}}>
          <div className="xl:h-[90%]">
            {" "}
            <img
              src={pg2}
              alt="img1"
              className="rounded-md object-cover h-full"
            />
          </div>
          <div className="flex flex-col gap-1 items-start tracking-wide">
            <h1 className="text-[#6B737A] text-sm">20-12-2024</h1>
            <p className="text-md font-bold">
              10 Ways to make your PG/Hostel room feel more like home
            </p>
            <button className="uppercase text-md font-bold text-[#00B1CE] flex items-center">
              Read More
              <MdKeyboardArrowRight className="text-[#00B1CE]" fontSize={20} />
            </button>
          </div>
        </div>
        <div className="flex flex-col gap-3 items-start" onClick={()=>{navigate("/blog-details")}}>
          <div className="xl:h-[90%]">
            {" "}
            <img
              src={pg3}
              alt="img1"
              className="rounded-md object-cover h-full"
            />
          </div>
          <div className="flex flex-col gap-1 items-start tracking-wide">
            <h1 className="text-[#6B737A] text-sm">20-12-2024</h1>
            <p className="text-md font-bold">
              10 Ways to make your PG/Hostel room feel more like home
            </p>
            <button className="uppercase text-md font-bold text-[#00B1CE] flex items-center">
              Read More
              <MdKeyboardArrowRight className="text-[#00B1CE]" fontSize={20} />
            </button>
          </div>
        </div>
      </div>
    </div>
  </>
);
}

export default Blogs
